module.exports = __webpack_public_path__ + "img/logo_podohotel.df9ee3a4.png";